import { connect } from 'react-redux';
import { IStoreState, IStateCollection } from 'src/entity/StateEntity';
import SupplierEditForm from 'src/components/common/SupplierEditForm';
import { Dispatch } from 'redux';

const mapStateToProps = ({
  userState: { isAgent, userInfo, isDomestic },
  drugStoreState: { drugStores },
  selectDoctorState: { doctorInfo },
}: IStoreState) => ({
  isAgent,
  userInfo,
  isDomestic,
  drugStores,
  doctorInfo,
});

const mapDispatchToProps = (dispatch: Dispatch<IStateCollection>) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SupplierEditForm);



// WEBPACK FOOTER //
// ./src/containers/SupplierEdit.ts